<template>
    <div>
        <div class="row">
            <div class="col-xl-12 mb-3">
                <div class="card mb-2">
                    <div class="card-body">
                        <label>
                            Campus
                        </label>
                        <campus-selector v-if="campusId" v-model="campusId" />
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <menu-edit-form
                            v-if="editedIndex || editedIndex === 0"
                            :key="menuKey"
                            v-model="menus[editedIndex].menuItems"
                            :v="v.menus.$each[editedIndex].menuItems"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import CampusSelector from '@/components/campuses/Selector';
import MenuEditForm from '@/components/header/MenuEditForm';

export default {
    components: {
        MenuEditForm,
        CampusSelector
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        v: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            menus: [],
            editedIndex: null,
            campusId: null,
            menuKey: 0
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    watch: {
        campusId(val, oldVal) {
            if (val === oldVal) {
                return;
            }

            const index = this.menus.findIndex(menu => menu.campusId === val);

            this.editedIndex = index;

            this.menuKey++;
        }
    },

    async created() {
        this.menus = [...this.value];

        try {
            const { id: defaultCampusId } = await this.getDefaultCampus();

            this.campusId = defaultCampusId;

            const index = this.menus.findIndex(
                menu => menu.campusId === defaultCampusId
            );

            this.editedIndex = index;
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getDefaultCampus: 'campuses/getDefault'
        })
    }
};
</script>
